import 'startbootstrap-stylish-portfolio/dist/css/styles.css';
import { Link } from "react-router-dom";

function LandingPage() {
    return (
    <div className="App">
     <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="description" content="" />
        <meta name="author" content="" />
        <title>Kluch Daily</title>
        <link rel="icon" type="image/x-icon" href="assets/favicon.ico" />
        <script src="https://use.fontawesome.com/releases/v6.3.0/js/all.js" crossorigin="anonymous"></script>
        <link href="https://cdnjs.cloudflare.com/ajax/libs/simple-line-icons/2.5.5/css/simple-line-icons.min.css" rel="stylesheet" />

        <link href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,700,300italic,400italic,700italic" rel="stylesheet" type="text/css" />
        
        <link href="css/styles.css" rel="stylesheet" />
    </head>
    <div id="page-top">
        
        
        
        <header class="masthead d-flex align-items-center" style={{
        maxHeight: '25vh',
      }}>
            <div class="container px-4 px-lg-5 text-center">
                <h1 class="mb-1">Kluch Daily</h1>
                <h3 class="mb-5"><em>Becoming better, together.</em></h3>
               
                <Link to="/register"><div class="btn btn-primary btn-xl m-3">Register</div></Link>
                <Link to="/login"><a class="btn btn-primary btn-xl">Log In</a></Link>
            </div>
        </header>
       
        <section class="content-section bg-light" id="about">
            <div class="container px-4 px-lg-5 text-center">
                <div class="row gx-4 gx-lg-5 justify-content-center">
                    <div class="col-lg-10">
                        <h2>Kluch Daily is the perfect platform to develop consistency and change your life.</h2>
                        <p class="lead mb-5">
                           Welcome to Kluch Daily, where transformation starts today! Our 21 day challenges are designed to help you break free from routine and cultivate positive habits. 
                           Whether you're looking to improve fitness, boost your creativity, or learn a new skill, our structured challenges provide the perfect framework for achieving
                           your goals with the support of our community.
                        </p>
                        <a class="btn btn-dark btn-xl" href="#services">More Information</a>
                    </div>
                </div>
            </div>
        </section>
        
        <section class="content-section bg-primary text-white text-center" id="services">
            <div class="container px-4 px-lg-5">
                <div class="content-section-heading">
                    <h3 class="text-secondary mb-0">Kluch Daily</h3>
                    <h2 class="mb-5">Features</h2>
                </div>
                <div class="row gx-4 gx-lg-5">
                    <div class="col-lg-3 col-md-6 mb-5 mb-lg-0">
                        <span class="service-icon rounded-circle mx-auto mb-3"><i class="icon-screen-smartphone"></i></span>
                        <h4><strong>Community</strong></h4>
                        <p class="text-faded mb-0">Join friends and family in exciting challenges!</p>
                    </div>
                    <div class="col-lg-3 col-md-6 mb-5 mb-lg-0">
                        <span class="service-icon rounded-circle mx-auto mb-3"><i class="icon-pencil"></i></span>
                        <h4><strong>Creativity</strong></h4>
                        <p class="text-faded mb-0">Create your own personal challenges.</p>
                    </div>
                    <div class="col-lg-3 col-md-6 mb-5 mb-md-0">
                        <span class="service-icon rounded-circle mx-auto mb-3"><i class="icon-trophy"></i></span>
                        <h4><strong>Trophies</strong></h4>
                        <p class="text-faded mb-0">
                            <i class="fas fa-heart"></i>
                            Earn trophies for your achivements.
                        </p>
                    </div>
                    
                    <div class="col-lg-3 col-md-6">
                        <span class="service-icon rounded-circle mx-auto mb-3"><i class="icon-calendar"></i></span>
                        <h4><strong>Progress Tracking</strong></h4>
                        <p class="text-faded mb-0">Keep track of your daily tasks.</p>
                    </div>
                </div>
            </div>
        </section>
        
        
        <div class="footer text-center">
            <div class="container px-4 px-lg-5">
                
                <p class="text-muted small mb-0">Copyright &copy; Kluch Daily 2025</p>
            </div>
            </div>
            </div>
    </div>
    )
}

export default LandingPage;